
import { Box, LinearProgress } from '@mui/material';

import '../style/progress.css'
export default function Progress(value) {

  return (
    <Box className='progress'>
      <LinearProgress sx={{
        "& .MuiLinearProgress-bar": {
          backgroundColor: "#e0cd60"
        }
      }} variant="buffer" value={value.value} valueBuffer={value.value} />
    </Box >

  );
}
